<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "skill_category",
        key: "category_id",
        url: {},
        output: false,
        stripe: false,
        order: "sort asc",
      },
      menus: [
        {
          label: "技术列表",
          name: "skill_list",
          auth: "/admin/skill/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
        {
          label: "分类列表",
          name: "skillcategory_list",
          auth: "/admin/skillcategory/lists",
        },
      ],
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/skillcategory/add",
        },
      ],
      query: {},
      filters: [{ label: "分类标题", name: "name", value: "", type: "input" }],
      tableCols: [
        { title: "ID", key: "category_id", width: 80, align: "center" },
        {
          title: "分类标题",
          key: "name",
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            const text = row.name;
            return h(
              "span",
              {
                style: {
                  "font-size": "14px",
                },
              },
              text
            );
          },
        },
        {
          title: "分类副标题",
          key: "sname",
          minWidth: 120,
          render: (h, params) => {
            const row = params.row;
            const text = row.sname;
            return h(
              "span",
              {
                style: {
                  "font-size": "14px",
                },
              },
              text
            );
          },
        },
        {
          title: "图片",
          key: "image",
          minWidth: 120,
          align: "center",
          viewimage: true,
        },
        {
          title: "显示",
          align: "center",
          key: "status",
          minWidth: 80,
          switch: true,
          disabled: false,
        },
        {
          title: "排序",
          align: "center",
          sortable: "custom",
          key: "sort",
          width: 90,
          editable: true,
        },
        {
          title: "创建时间",
          align: "center",
          key: "create_time",
          minWidth: 170,
        },
        {
          title: "操作",
          align: "center",
          minWidth: 150,
          key: "handle",
          handle: [
            (vm, h, currentRow, param) => {
              let directives = [
                { name: "auth", value: "/admin/skillcategory/edit" },
              ];
              this.currentRow = currentRow;
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="primary"
                  style={{ margin: "4px 5px" }}
                >
                  编辑
                </Button>
              );
            },
            "delete",
          ],
          auth: {
            edit: "/admin/skillcategory/edit",
            delete: "/admin/skillcategory/del",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({
        name: "skillcategory_add",
        query: {
          action: "add",
          type: 1,
        },
      });
    },
    toEdit(row) {
      let category_id = row.category_id;
      $utils.url.push({
        name: "skillcategory_edit",
        query: { action: "edit", kv: category_id, type: 1 },
      });
    },
    // rowClassName(row, index) {
    //   if (row.pid === 0) {
    //     return 'demo-table-info-row'
    //   }
    //   return ''
    // },
  },
};
</script>
<style>
.ivu-table .demo-table-info-row td {
  background-color: #f8f8f9;
}
</style>
